module.exports = __webpack_public_path__ + "static/media/ActivityIcon.c2de110b.svg";